import { createFileRoute, redirect } from '@tanstack/react-router';
import { MFRECO_POSITION_DAY_BASE_PATH } from '../../../../../../../../../features/mutual-funds/reconciliation/position-day/mfreco-position-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/')({
  beforeLoad: () => {
    throw redirect({ to: MFRECO_POSITION_DAY_BASE_PATH });
  },
  preload: false,
});
